import { defineMeta } from '@/registry/types';

export const splitBarMeta = defineMeta({
  name: 'SplitBar',
  level: 'molecule',
  category: 'data-display',
  classification: 'custom',
  description:
    'Proportional bar split into labelled segments — the compact severity or priority breakdown used in tables and cards.',
  baseLibrary: 'custom',
  importPath: '@/molecules/SplitBar',
  requiredProps: ['segments', 'label'],
  optionalProps: ['scale', 'height', 'hideValues'],
  supportedStates: ['default', 'empty'],
  designTokens: ['severity', 'chart'],
  accessibility: [
    'Renders role="img" with an aria-label enumerating every segment and its count.',
    'Segment counts are rendered as visible text; severity medium and low fall in the contrast relief band on light surfaces and must not rely on colour.',
    'A 2px surface gap separates adjacent fills, providing the secondary encoding colour-vision separation requires.',
  ],
  usageExamples: [
    '<SplitBar label="Findings by severity" segments={[{ key: "critical", value: 3 }, { key: "high", value: 12 }]} />',
  ],
  antiPatterns: [
    'Do not set hideValues unless the same counts appear immediately adjacent.',
    'Do not use for more than about six segments — use a stacked BarChart.',
  ],
  llmSafe: true,
  whenToUse: ['A one-line part-to-whole breakdown inside a row or card'],
  whenNotToUse: ['Trends over time, or many categories'],
});

export default splitBarMeta;
